import { GetKidHistoryResponse } from '../../../entity/interface/iChannelSeriesHistory';
import { IChannelSeriesHistoryRepository } from '../../repositories/interfaces/iChannelSeriesHistoryRepository';
import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
export interface IGetProfileWatchesHistoryUseCase {
    execute(
        apiKey: string,
        profileName: string,
        userName: string,
        pageNumber: number,
        pageSize: number,
        identityToken: string
    ): Promise<GetKidHistoryResponse>;
}
class GetProfileWatchesHistoryUseCase implements IGetProfileWatchesHistoryUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get channelSeriesHisRepo(): IChannelSeriesHistoryRepository {
        return container.resolve<IChannelSeriesHistoryRepository>(DI.REPOSITORIES.IChannelSeriesHistoryRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(
        apiKey: string,
        profileName: string,
        userName: string,
        pageNumber: number,
        pageSize: number,
        identityToken: string
    ): Promise<GetKidHistoryResponse> {
        return await this.channelSeriesHisRepo.getProfileWatchesHistory(
            apiKey,
            profileName,
            userName,
            pageNumber,
            pageSize,
            identityToken
        );
    }
}

export default GetProfileWatchesHistoryUseCase;
